export default __webpack_public_path__ + "static/media/photo1.497ad377.jpg";